/**
 * Recursively checks the keys and values of a JSON object for length constraints.
 *
 * @param {Object} json - The JSON object to check.
 * @param {number} maxKeyLength - The maximum allowed key length.
 * @param {number} maxValueLength - The maximum allowed value length.
 * @throws {string} Throws an error message if key or value lengths exceed the specified limits.
 */
export const checkJsonKeysLength = async (json, maxKeyLength, maxValueLength) => {
  // Iterate through each key in the JSON object
  for (const key in json) {
    // Check if the value associated with the key is an object (nested object)
    if (typeof json[key] === "object") {
      // Recursively call the function to check the nested object
      await checkJsonKeysLength(json[key], maxKeyLength, maxValueLength)
    } else {
      // Check if the key's length exceeds the maximum allowed length
      if (key.length > maxKeyLength) {
        // Throw an error if the key length is too long
        throw `Key <strong style="word-break: break-all; hyphens: auto;">${key}</strong> exceeds the maximum allowed length of ${maxKeyLength} characters.`
      }
      // Check if the value is a string and its length exceeds the maximum allowed length
      if (typeof json[key] === "string" && json[key].length > maxValueLength) {
        // Throw an error if the value length is too long
        throw `Value for key <strong style="word-break: break-all; hyphens: auto;">${key}</strong> exceeds the maximum allowed length of ${maxValueLength} characters.`
      }
    }
  }
}
